import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValueWithType, updateRecoilStateWithType } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IMultiBookingTrainOffer } from "../../../Orchestrator/Recoils/MultiBookingAtom";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { TrainType } from "../../../Orchestrator/Types/Types/TrainTypes";
import dayjs from "dayjs";

export interface IChangeTrainActionParams {
  tripDate: dayjs.Dayjs;
  trainType: TrainTypeEnum;
  originalTrain: TrainType;
  newTrain: TrainType;
}

class ChangeTrainAction extends BaseAction<void, IChangeTrainActionParams> {
  async run(): Promise<void> {
    try {
      const { tripDate, trainType, newTrain } = this.params!;

      const multiBookingSelectedTrainsState = getRecoilStateValueWithType("multiBookingSelectedTrainsAtom");

      if (!multiBookingSelectedTrainsState || multiBookingSelectedTrainsState?.length === 0) {
        console.error('No trains selected for multi-booking.');
        return;
      }

      const formattedTripDate = tripDate.format('YYYY-MM-DD');

      const updatedSelectedTrains: IMultiBookingTrainOffer[] = multiBookingSelectedTrainsState.map(trainOffer => {
        if (trainOffer.date === formattedTripDate) {
          if (trainType === TrainTypeEnum.outbound && trainOffer.outbound) {
            return {
              ...trainOffer,
              outbound: {
                ...trainOffer.outbound,
                selected: true,
                train: newTrain
              }
            };
          } else if (trainType === TrainTypeEnum.inbound && trainOffer.inbound) {
            return {
              ...trainOffer,
              inbound: {
                ...trainOffer.inbound,
                selected: true,
                train: newTrain
              }
            };
          }
        }
        return trainOffer;
      });

      updateRecoilStateWithType("multiBookingSelectedTrainsAtom", updatedSelectedTrains);
    } catch (error) {
      console.error('Error in ChangeTrainAction:', error);
    }
  }
}

export const changeTrainAction = new ChangeTrainAction();
